<template lang="pug">
  nav
    .shape
      svg(viewBox='0 0 800 70', preserveAspectRatio='none')
        path(style='fill:#ffffff;', d='M800,60c0,0-58-11-162-11c-164,0-227,21-403,21C102,70,0,60,0,60V0.2h800V60z')
    ul
      li.mobile
        router-link(to='/', exact, data-title='Home') Home
      li
        router-link(to='/ballsaal', exact, data-title='Ballsaal', @mouseenter.native='linkHover') Ballsaal
      li
        router-link(to='/co-working', exact, data-title='Co-Working', @mouseenter.native='linkHover') Co-Working
      li
        router-link(to='/kaffeehaus', exact, data-title='Kaffeehaus', @mouseenter.native='linkHover') Kaffeehaus
      li
        router-link(to='/hof', exact, data-title='Der Hof', @mouseenter.native='linkHover') Der&nbsp;Hof
      li.mobile
        router-link(to='/kontakt', exact, data-title='Kontakt') Kontakt
    .clear
</template>

<script>
  import {TimelineLite, Back} from 'gsap'
  import SplitText from '@/assets/js/SplitText.min.js'

  export default {
    data () {
      return {
      }
    },
    mounted () {
      let els = [...document.querySelectorAll('nav li a')]
      for (let el of els) {
        let split = new SplitText(el, {type: 'chars', charsClass: 'char'})
        split
      }
    },
    methods: {
      linkHover (ev) {
        let direction = ev.movementX < 0 ? -1 : 1
        let els = ev.target.querySelectorAll('.char')
        // anime({
        //   targets: els,
        //   translateY: [
        //     {value: -3, duration: 250, easing: 'easeOutBack'},
        //     {value: 0, duration: 1000, easing: 'easeOutBack'}
        //   ],
        //   delay: function (el, i, l) {
        //     return i * 31.25 * direction
        //   }
        // })
        // TweenMax.staggerTo(els, 0.25, {y: -2.5, repeat: 1, yoyo: true, ease: Power3.easeInOut}, 0.0625 * direction)
        let tl = new TimelineLite()
        tl.staggerTo(els, 0.25, {y: -3, ease: Back.easeOut}, 0.031 * direction)
        tl.staggerTo(els, 1, {y: 0, ease: Back.easeOut}, 0.031 * direction, 0.25)
      }
    }
  }
</script>

<style lang="scss">
  @import "~utils";
  nav {
    background: transparent;
    width: 100%;
    padding: $gutter*1.5 0 $gutter*3;
    position: fixed;
    top: 0;
    left: 0;
    transform: scale3d(1,0,1);
    transform-origin: center top;
    transition: all .75s $easeInOut;
    // margin-top: 3.4rem;
    padding-top: $gutter*3;
    z-index: 3;

    @include desktop {
      padding: 0;
      height: $navHeight;
      margin-top: 0;
      transform: translate3d(0, -100%, 0);
      transition-delay: 0s;
      padding-top: 0;
      z-index: 1;
      position: absolute;
    }
    .shape {
      svg {
        position: absolute;
        top: 0;
        left: 0;
        min-width: 100%;
        height: 100%;
      }
    }

    ul {
      li {
        text-align: center;
        transform: translate3d(0, $gutter * -1, 0);
        opacity: 0;
        transition: all .5s $easeInOut;
        @include desktop {
          width: 20%;
          display: inline-block;
          
          &:nth-child(3) {
            margin-right: 20%;
          }

          &.mobile {
            display: none;
          }
        }
        a {
          @include sans;
          text-transform: uppercase;
          font-size: .875rem;
          font-weight: bold;
          letter-spacing: 0.2em;
          display: block;
          padding: $gutter 0;
          .char {
            display: inline-block;
            backface-visibility: hidden;
            transition: color .25s $easeOut;
          }
          @include desktop {
            padding: 0;
            line-height: $navHeight;
            &:hover .char {
              color: $gold;
              transition: color .25s $easeOut;
              transition-delay: .125s;
            }
          }
          &.router-link-active .char {
            color: $gold;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Nav.vue?7e6e1f28